export default "/assets/images/current-room-status-thumbnail.f14b16b21ee5b7f9.jpg";